// extracted by mini-css-extract-plugin
export default {"button":"Button_button__kr7-6","button-active":"Button_button-active__FxEmO"};